<template>
    <v-form v-model="valid" ref="form">
        <v-container fluid class="hidden-print-only">
          <v-row>

            <v-col cols="12" md="8" offset-lg="2" lg="7" xl="6" offset-xl="3">
              <v-row>
                <v-col cols="12" class="white ml-2 my-3">
                  <v-row>
                    <v-col cols="12">
                      <h2 class="underline mb-4">Reisedaten</h2>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="name" label="Name, Vorname" class="mt-0 pt-0" hide-details="auto" required filled/>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="purpose" label="Anlass & Zieladresse" class="mt-0 pt-0" hide-details="auto" required filled/>
                    </v-col>
                    <v-col cols="12" md="6">
                      <!--                            <v-select :items="countryList" v-model="country" item-text="name" return-object="true" value="Deutschland" label="Zielland" v-on:change="updateDayData" class="mt-0 pt-0" hide-details="auto" required filled/>-->
                      <v-autocomplete
                          v-model="country"
                          :items="countryList"
                          return-object
                          item-text="name"
                          v-on:change="updateDayData"
                          dense
                          filled
                          label="Zielland"
                          class="mt-0 pt-0" hide-details="auto" required
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-menu ref="menuDateFrom" v-model="dateFromPickerMenu" :close-on-content-click="false" :return-value.sync="dateFrom" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              v-model="dateFromText"
                              label="Beginn der Reise"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-on="on"
                              class="mt-0 pt-0" filled
                              hide-details="auto"/>
                        </template>
                        <v-date-picker v-model="dateFrom" no-title scrollable @change="$refs.menuDateFrom.save(dateFrom), dateFromPickerMenu = false" min="2020-01-01" locale="de"/>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-text-field
                          v-model="timeFromValue"
                          label="Uhrzeit"
                          prepend-icon="mdi-clock"
                          v-on:change="updateDayData"
                          :rules="timeRules"
                          filled
                          hide-details="auto"/>
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-menu ref="menuDateTo" v-model="dateToPickerMenu" :close-on-content-click="false" :return-value.sync="dateTo" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                              v-model="dateToText"
                              label="Ende der Reise"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-on="on"
                              class="mt-0 pt-0" filled
                              hide-details="auto"/>
                        </template>
                        <v-date-picker v-model="dateTo" no-title scrollable @change="$refs.menuDateTo.save(dateTo), dateToPickerMenu = false" min="2020-01-01" locale="de"/>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-text-field
                          v-model="timeToValue"
                          label="Uhrzeit"
                          prepend-icon="mdi-clock"
                          v-on:change="updateDayData"
                          :rules="timeRules"
                          filled
                          hide-details="auto"/>
                    </v-col>
                    <v-col cols="6" offset="6">
                      <v-checkbox v-model="overnightStay" class="mt-0 pt-0" hide-details="auto" label="mit Übernachtung" v-if="isFollowingDay" v-on:change="updateDayData"/>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <h2 class="underline">Fahrtkosten</h2>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="8" class="d-flex align-content-center">
                      <div class="text-no-wrap pr-8">Privat-PKW</div>
                      <div><v-text-field v-model="privatPkwMenge" label="gefahrene KM" class="mt-0 pt-0" filled dense/></div>
                      <div class="px-4 align-self-baseline">x</div>
                      <div><v-text-field v-model="privatPkwFaktor" label="€/km" class="mt-0 pt-0" filled dense/></div>
                    </v-col>
                    <v-col cols="6" md="4">
                      {{ formatDecimal(totalPrivatPwk) }} €
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-2"><v-divider /></v-col>
                  </v-row>
                  <v-row class="d-flex align-start">
                    <v-col cols="6" md="8">
                      <span>Öffentliche Verkehrmittel, Taxi <small>(lt. beigefügten Belegen)</small></span>
                    </v-col>
                    <v-col cols="6" md="4" class="d-flex align-center">
                      <v-text-field v-model="totalOepnv" class="mt-0 pt-0 mr-3 d-inline-block" filled dense/> €
                    </v-col>
                  </v-row>

                  <v-row class="mt-5">
                    <v-col cols="12">
                      <h2 class="underline">Übernachtungskosten</h2>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="8">
                      <span>Tatsächliche Kosten <small class="d-block">(lt. beigefügten Belegen, ohne Verpflegung)</small></span>
                    </v-col>
                    <v-col cols="6" md="4" class="d-flex align-center">
                      <v-text-field v-model="overnight" class="mt-0 pt-0 mr-3 d-inline-block" filled dense/> €
                    </v-col>

                  </v-row>
                  <!--v-row>
                      <v-col cols="6" md="8" >
                          <div>Pauschale <small>(nur bei Auslagenersatz durch den Arbeitgeber)</small></div>
                          <div class="d-flex align-center mt-2">
                              <div style="width: 100px">
                              <v-text-field v-model="overnightPauschalMenge" class="mt-0 pt-0 mr-4" filled dense hide-details="auto"/>
                              </div>Übernachtungen x {{country.overnightRate}} € (Inland)
                          </div>
                      </v-col>
                      <v-col cols="6" md="4" class="d-flex ">
                          {{ formatDecimal(totalOvernightPauschal) }} €
                      </v-col>
                  </v-row-->

                  <v-row>
                    <v-col cols="12">
                      <h2 class="underline">Verpflegungspauschale</h2>
                    </v-col>
                  </v-row>
                  <v-row v-if="dayData.length === 0">
                    <v-col cols="12" class="font-italic" >Bitte wählen Sie einen Reisezeitraum aus</v-col>
                  </v-row>
                  <div v-else>
                    <v-row class="font-weight-bold" >
                      <v-col cols="2">Datum</v-col>
                      <v-col cols="2">Pauschale</v-col>
                      <v-col cols="2">Frühstück</v-col>
                      <v-col cols="2">Mittagessen</v-col>
                      <v-col cols="2">Abendessen</v-col>
                      <v-col cols="2">Summe</v-col>
                    </v-row>
                    <v-row :key="day" :index="i" v-for="(day,i) in dayData">
                      <v-col cols="2">{{ day.date }}</v-col>
                      <v-col cols="2">{{ day.rate }} €</v-col>
                      <v-col cols="2"><v-checkbox v-model="day.breakfast" class="mt-0" hide-details="auto"></v-checkbox></v-col>
                      <v-col cols="2"><v-checkbox v-model="day.lunch" class="mt-0" hide-details="auto" ></v-checkbox></v-col>
                      <v-col cols="2"><v-checkbox v-model="day.dinner" class="mt-0" hide-details="auto"></v-checkbox></v-col>
                      <v-col cols="2">{{ dayDataTotal(day).toFixed(2) }} €</v-col>
                      <v-col cols="12" class="pt-1 pb-0" v-if="i !== dayData.length - 1"><v-divider/></v-col>
                    </v-row>
                  </div>



                  <v-row class="mt-5">
                    <v-col cols="12">
                      <h2 class="underline">Reisenebenkosten</h2>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="8">
                      <span>Tatsächliche Kosten <small class="d-block">(lt. beigefügten Belegen, z.B. für Telekommunikation, Porto, Parkplatz, etc.)</small></span>
                    </v-col>
                    <v-col cols="6" md="4" class="d-flex align-center">
                      <v-text-field v-model="totalOther" class="mt-0 pt-0 mr-3 d-inline-block" filled dense/> €
                    </v-col>
                  </v-row>

                  <v-row><v-col><v-divider/></v-col></v-row>

                  <v-row>
                    <v-col cols="6" md="8" class="text-right">

                    </v-col>
                    <v-col cols="6" md="4">

                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="8" class="text-right">
                      Fahrtkosten<br/>
                      Verpflegungspauschale<br/>
                      Übernachtungskosten<br/>
                      Reisenebenkosten
                    </v-col>
                    <v-col cols="6" md="4">
                      {{ formatDecimal(totalFahrtKosten) }} €<br/>
                      {{ formatDecimal(totalVerpflegung) }} €<br/>
                      {{ formatDecimal(totalOvernight) }} €<br/>
                      {{ formatDecimal(totalOtherAsNumber) }} €
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" md="8" class="text-right">
                      <h3>Reisekosten Gesamt</h3>
                    </v-col>
                    <v-col cols="6" md="4">
                      <h3>{{ formatDecimal(grandTotal) }} €</h3>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-2"><v-divider /></v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" class="text-right">
                      <v-btn color="primary" @click="showOverlay = true, scrollToTop()" alt="Reisekosten zusammenfassen und drucken.">Zusammenfassung drucken</v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-right mt-5">
                      <v-btn color="light-green lighten-2" href="https://www.reisekostenrechner.com" target="_blank" class="white--text" alt="Zur Hilfeseite des Reisekostenrechners.">
                        Brauchen Sie Hilfe? &gt;&gt;
                      </v-btn>
                    </v-col>
                  </v-row>

                  <Disclaimer/>
                  <small><a href="https://www.amz-steuer.de/impressum.html">Impressum</a></small>
                </v-col>
              </v-row>
            </v-col>
            <v-col offset="2" cols="8" offset-md="0" md="4" lg="3" xl="3">
              <div class="mx-lg-5 max-width-400">
                <NewsPreview/>
              </div>

            </v-col>
          </v-row>

        </v-container>

        <v-overlay
                absolute="true"
                opacity="1"
                :value="showOverlay"
                z-index="100"
                color="#ffffff" dark="false" class="align-start align-content-start justify-center">
            <v-container class="mt-3">
                <v-row>
                    <v-col cols="12"><h3>Reisedaten</h3></v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">Name:</v-col><v-col cols="9">{{name}}</v-col>
                    <v-col cols="3">Anlass & Reiseziel:</v-col><v-col cols="9">{{purpose}}</v-col>
                    <v-col cols="3">Reisezeitpunkt:</v-col><v-col cols="9"><span v-if="dateFromText.length > 0 && dateToText.length >0">{{dateFromText}} {{timeFromValue}} - {{dateToText}} {{timeToValue}}</span></v-col>
                    <v-col cols="12" class="py-2"><v-divider/></v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"><h3>Fahrtkosten</h3></v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">Privat-PKW:</v-col><v-col cols="4">{{privatPkwMenge.length > 0 ? privatPkwMenge : 0}} km * {{privatPkwFaktor}} €</v-col><v-col cols="2"> {{ formatDecimal(totalPrivatPwk) }} €</v-col>
                    <v-col cols="10">Öffentliche Verkehrsmittel,Taxi:</v-col><v-col cols="2">{{formatDecimal(totalOepnvAsNumber)}} €</v-col>
                    <v-col cols="12" class="py-2"><v-divider/></v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"><h3>Übernachtungskosten</h3></v-col>
                </v-row>
                <v-row>
                    <v-col cols="10">
                        <span>Tatsächliche Kosten <small class="d-block">(lt. beigefügten Belegen, ohne Verpflegung)</small></span>
                    </v-col>
                    <v-col cols="2">
                        {{overnight}} €
                    </v-col>
                    <v-col cols="12" class="py-2"><v-divider/></v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"><h3>Verpflegungspauschale</h3></v-col>
                </v-row>
                <v-row class="font-weight-bold" >
                    <v-col cols="2">Datum</v-col>
                    <v-col cols="2">Pauschale</v-col>
                    <v-col cols="2">Frühstück</v-col>
                    <v-col cols="2">Mittagessen</v-col>
                    <v-col cols="2">Abendessen</v-col>
                    <v-col cols="2">Summe</v-col>
                </v-row>
                <v-row :key="day" :index="i" v-for="(day,i) in dayData">
                    <v-col cols="2">{{ day.date }}</v-col>
                    <v-col cols="2">{{ day.rate }} €</v-col>
                    <v-col cols="2"><v-icon v-if="day.breakfast">mdi-check</v-icon><v-icon v-else>mdi-minus</v-icon></v-col>
                    <v-col cols="2"><v-icon v-if="day.lunch">mdi-check</v-icon><v-icon v-else>mdi-minus</v-icon></v-col>
                    <v-col cols="2"><v-icon v-if="day.dinner">mdi-check</v-icon><v-icon v-else>mdi-minus</v-icon></v-col>
                    <v-col cols="2">{{ dayDataTotal(day).toFixed(2) }} €</v-col>
                </v-row>
                <v-row><v-col  class="py-2"><v-divider/></v-col></v-row>
                <v-row>
                    <v-col cols="12"><h3>Reisenebenkosten</h3></v-col>
                </v-row>
                <v-row>
                    <v-col cols="10">
                        <span>Tatsächliche Kosten <small class="d-block">(lt. beigefügten Belegen, z.B. für Telekommunikation, Porto, Parkplatz, etc.)</small></span>
                    </v-col>
                    <v-col cols="2">
                        {{formatDecimal(totalOtherAsNumber)}} €
                    </v-col>
                    <v-col cols="12" class="py-2"><v-divider/></v-col>
                </v-row>
                <v-row>
                    <v-col cols="10" class="text-right">
                        Fahrtkosten<br/>
                        Verpflegungspauschale<br/>
                        Übernachtungskosten<br/>
                        Reisenebenkosten
                    </v-col>
                    <v-col cols="2">
                        {{ formatDecimal(totalFahrtKosten) }} €<br/>
                        {{ formatDecimal(totalVerpflegung) }} €<br/>
                        {{ formatDecimal(totalOvernight) }} €<br/>
                        {{ formatDecimal(totalOtherAsNumber) }} €
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="10" class="text-right">
                        <h3>Reisekosten Gesamt</h3>
                    </v-col>
                    <v-col cols="2">
                        <h3>{{ formatDecimal(grandTotal) }} €</h3>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-2"><v-divider /></v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <p>
                            Die Vollständigkeit und Richtigkeit der Angaben wird hiermit bestätigt.
                        </p>
                    </v-col>
                    <v-col cols="3"  class="mt-8">
                        <div style="border-top: 1px solid #ccc;"></div>
                        Datum
                    </v-col>
                    <v-col cols="6"  class="mt-8">
                        <div style="border-top: 1px solid #ccc;"></div>
                        Unterschrift
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <small>Erstellt am {{currentDate()}} um {{currentTime()}}</small>
                    </v-col>
                </v-row>
                <v-row class="hidden-print-only">
                    <v-col cols="12" class="pt-0 pb-2"><v-divider /></v-col>
                    <v-col cols="6">
                        <v-btn color="primary" @click="showOverlay = false">
                            Zurück
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <v-btn color="primary" @click="print">
                            Drucken
                        </v-btn>
                    </v-col>
                </v-row>
                <Disclaimer/>
            </v-container>

        </v-overlay>
    </v-form>
</template>

<script>
    import countryList from "../countries";
    import Disclaimer from "../components/Disclaimer";
    import {fetchAndParseFeed} from "@/utils/rss";
    import NewsPreview from "@/views/NewsPreview.vue";

    var moment = require('moment');
    const timePattern = /^[0-9]{2}:[0-9]{2}$/;

    export default {
        name: "ReisekostenRechner",
        components: {NewsPreview, Disclaimer},
        data: () => ({
            valid: false,
            name: '',
            country: countryList[0],
            dateFromValue: '',
            timeFromValue: '00:00',
            dateToValue: '',
            timeToValue: '00:00',
            overnightStay: true,
            dateRangeValue: [],
            dateFromPickerMenu: false,
            dateToPickerMenu: false,
            dayData: [],
            purpose: '',
            taxInfo: '',
            privatPkwMenge: '',
            privatPkwFaktor: '0,30',
            totalOepnv: '',
            overnight: '',
            overnightPauschalMenge: '',
            totalOther: '',
            showOverlay: false,
            timeRules: [
                value => !!value || 'Bitte ausfüllen.',
                value => {
                    return (timePattern.test(value) && moment(value, 'HH:mm').isValid()) || 'Bitte im Format HH:MM eingeben'
                },
            ]
        }),
        computed: {
            countryList() {
                return countryList
            },
            dateFrom: {
                get: function () {
                    return this.dateFromValue;
                },
                set: function (newValue) {
                    this.dateFromValue = newValue;
                    this.updateDayData();
                }
            },
            dateTo: {
                get: function () {
                    return this.dateToValue;
                },
                set: function (newValue) {
                    this.dateToValue = newValue;
                    this.updateDayData();
                }
            },
            dateFromText () {
                if (this.dateFromValue.length === 0) {
                    return '';
                }
                return moment(this.dateFromValue, 'YYYY-MM-DD').format('DD.MM.YYYY') ;
            },
            dateToText () {
                if (this.dateToValue.length === 0) {
                    return '';
                }
                return moment(this.dateToValue, 'YYYY-MM-DD').format('DD.MM.YYYY') ;
            },
            isSameDay() {
                var startDate = moment(this.dateFromValue, 'YYYY-MM-DD');
                var endDate = moment(this.dateToValue, 'YYYY-MM-DD');
                return startDate.isSame(endDate, 'day');
            },
            isFollowingDay() {
                var startDate = moment(this.dateFromValue, 'YYYY-MM-DD');
                var endDate = moment(this.dateToValue, 'YYYY-MM-DD');
                return moment.duration(endDate.diff(startDate)).asDays() === 1;
            },
            totalPrivatPwk() {
                return (this.privatPkwMenge * this.privatPkwFaktor.replace(',','.'));
            },
            totalOepnvAsNumber() {
                let oepnv = parseFloat(this.totalOepnv.replace(',', '.'));
                if (isNaN(oepnv)) {
                    oepnv = 0;
                }
                return oepnv;
            },
            totalFahrtKosten() {
                return this.totalPrivatPwk + this.totalOepnvAsNumber;
            },
            totalVerpflegung() {
                let total = 0;
                this.dayData.forEach(function (day) {
                    total += day.total;
                });
                return total;
            },
            totalOvernightPauschal() {
                return this.overnightPauschalMenge * this.country.overnightRate;
            },
            totalOvernight() {
                let overnight = parseFloat(this.overnight.replace(',', '.'));
                if (isNaN(overnight)) {
                    overnight = 0;
                }
                return overnight + this.totalOvernightPauschal;
            },
            totalOtherAsNumber() {
                let other = parseFloat(this.totalOther.replace(',', '.'));
                if (isNaN(other)) {
                    other = 0;
                }
                return other;
            },

            grandTotal() {
                let total = 0;

                total += this.totalFahrtKosten;
                total += this.totalVerpflegung;
                total += this.totalOvernight;
                total += this.totalOtherAsNumber;
                return total;
            }
        },
        methods : {
            allowedMinutes: m => m % 5 === 0,
            updateDayData() {
                if (this.dateFromValue.length === 0 || this.timeFromValue.length === 0 || this.dateToValue.length === 0 || this.timeToValue.length === 0) {
                    this.dayData = [];
                }
                else {
                    var startTime = moment(this.timeFromValue, 'HH:mm');
                    var startDate = moment(this.dateFromValue, 'YYYY-MM-DD');
                    startDate.hour(startTime.hour());
                    startDate.minute(startTime.minute());
                    var endTime = moment(this.timeToValue, 'HH:mm');
                    var endDate = moment(this.dateToValue, 'YYYY-MM-DD');
                    endDate.hour(endTime.hour());
                    endDate.minute(endTime.minute());

                    var dayData = [];
                    var index;
                    for (index = startDate.clone(); index.isSameOrBefore(endDate, 'day'); index.add(1, 'day')) {

                        let totalMinutes = moment.duration(endDate.diff(startDate)).as('minutes');

                        if (this.isSameDay) {
                            this.addDayData(dayData, index, totalMinutes <= 480 ? 0 : this.country.partialDay);
                            break;
                        }
                        else if (this.isFollowingDay && this.overnightStay === false) {
                            let rate = totalMinutes <= 480 ? 0 : this.country.partialDay;
                            rate = (this.timeFromValue === '00:00') ? this.country.wholeDay : rate;  // Spezialfall 1. Tag 24 Std.
                            this.addDayData(dayData, index, rate);
                            index.add(1, 'day');
                            this.addDayData(dayData, index, 0);
                            break;
                        }
                        else {
                            let rate = this.country.wholeDay;

                            if (index.isSame(startDate, 'day') || index.isSame(endDate, 'day')) {
                                rate = this.country.partialDay;
                            }

                            this.addDayData(dayData, index, rate);
                        }

                    }
                    this.dayData =  dayData;
                }
            },
            addDayData(dayData, date, rate) {
                dayData.push(
                    {
                        date: date.format('DD.MM.YYYY'),
                        rate: rate, total: 0,
                        breakfast: false, lunch: false, dinner: false,
                    });
            },
            dayDataTotal(dayData) {
                var dayTotal = dayData.rate;
                if (dayData.breakfast === true) {
                    dayTotal -= this.country.wholeDay * 0.20;
                }
                if (dayData.lunch === true) {
                    dayTotal -= this.country.wholeDay * 0.40;
                }
                if (dayData.dinner === true) {
                    dayTotal -= this.country.wholeDay * 0.40;
                }

                dayTotal = Math.max(dayTotal, 0);

                dayData.total = dayTotal;
                return dayTotal;
            },
            formatDecimal(val) {
                if (typeof val === 'number') {
                    return val.toFixed(2).replace('.',',');
                }
                return val;
            },
            validate () {
                console.log("validate");
                this.$refs.form.validate();
            },
            scrollToTop() {
                window.scrollTo(0,0);
            },
            print() {
                window.print()
            },
            currentDate() {
                return moment().format("DD.MM.YYYY");
            },
            currentTime() {
                return moment().format("HH:mm");
            }
        }
    }
</script>

<style scoped>
    h2 {
        font-size: 20px;
    }

    h2.underline,
    h3.underline {
        border-bottom: 1px solid #03A9F4;
    }
    .v-overlay__content {
        width: 100%;
        display: block;
    }

    .max-width-400 {
      max-width: 400px;
    }

    @media print {
        h3 {
            background-color: #eee;
            color: #33466d;
        }

        header {
            box-shadow: none;
        }

        .row {
            font-size: 12px;
        }
        .col {
            padding-top: 2px;
            padding-bottom: 2px;
        }
    }
</style>